import React from 'react';
import TrashIcon from 'assets/icon-trash';
import { ClearButton } from 'components/common/styled/common-styled';
import { CreditCode } from 'types/credit-codes';
import { useBrandCurrency } from 'hooks/useBrandCurrency';
import { currencyFormat } from 'utils';
import styled from 'styled-components';
import usePoints from 'hooks/usePoints';
import { useTranslation } from 'react-i18next';
import { PromoAmount } from './styles';

const CreditCodeItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

interface CreditCodeItemProps {
  creditCode: CreditCode;
  totalCartDiscount: number;
  removeCreditCode?: (code: string) => void;
  isPayingWithPoints?: boolean;
}

const CreditCodeItem = ({
  creditCode,
  totalCartDiscount,
  removeCreditCode,
  isPayingWithPoints,
}: CreditCodeItemProps) => {
  const currency = useBrandCurrency();
  const { count: totalCartDiscountPoints } = usePoints(totalCartDiscount);
  const { t } = useTranslation();

  return (
    <CreditCodeItemContainer>
      <p>{creditCode.code}</p>
      <PromoAmount>
        {isPayingWithPoints
          ? t('pointsWithCount', { count: totalCartDiscountPoints })
          : currencyFormat(currency)(totalCartDiscount)}
      </PromoAmount>
      <ClearButton
        onClick={() => removeCreditCode?.(creditCode.code)}
        data-testid="delete-credit-code"
      >
        <TrashIcon />
      </ClearButton>
    </CreditCodeItemContainer>
  );
};

export default CreditCodeItem;
